import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { CiclosResponse } from "@p-p-portafolio/promociones/interfaces/ciclos";
import { SwalService } from "@shared/utils/swal.service";
import { CiclosService } from "@p-p-portafolio/promociones/services/ciclos.service";
import { ConfirmDeletionComponent } from "@shared/components/confirm-deletion/confirm-deletion.component";
import { Column } from "@shared/components/generic-table/types/column.type";
import { Row } from "@shared/components/generic-table/types/row.type";
import { CiclosFormComponent } from "./ciclos-form/ciclos-form.component";
import Swal from "sweetalert2";

@Component({
    selector: "app-ciclos",
    templateUrl: "./ciclos.component.html",
    styleUrls: ["./ciclos.component.css"],
})
export class CiclosComponent implements OnInit {
    public dataSource: any = [];
    public loading: boolean = true;
    public columns = [
        { field: "iCiclo", header: "Ciclo" },
        { field: "actions", header: "Acciones" },
    ];

    promocion = "";
    createForm: boolean = false;
    valueNew: number = 0;

    constructor(
        public dialog: MatDialog,
        private ciclosService: CiclosService,
        private swalService: SwalService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        const routeParams = this.route.snapshot.paramMap;
        this.promocion = String(routeParams.get("promocion"));
        this.getDataSource();
    }

    actionHandler(action: "create" | "update" | "delete", rowData?: any) {
        if (action === "create") {
            this.createAction();
        }

        if (action === "update") {
            this.swalService.error("Este dato no se puede actualizar");
        }

        if (action == "delete") {
            this.deleteAction(rowData);
        }
    }

    goBack() {
        window.history.back();
    }

    createAction() {
        this.createForm = true;
    }

    deleteAction(rowData) {
        Swal.fire({
            title: "Eliminar ciclo",
            text: "¿Estas seguro de eliminar el ciclo?",
            icon: "warning",
            showCancelButton: true,
            iconColor: "#d33",
            confirmButtonColor: "#d33",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "No",
            heightAuto: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.ciclosService.delete(this.promocion, rowData.iCiclo).subscribe((res) => {
                    if (res) {
                        this.swalService.success("Ciclo eliminado correctamente").then(() => {
                            this.getDataSource();
                        });
                    } else {
                        this.swalService.error(res.errors[0]);
                    }
                });
            }
        });
    }

    getDataSource() {
        this.ciclosService.getAll(this.promocion).subscribe((res) => {
            this.dataSource = res;
            this.loading = false;
        });
    }

    saveNew() {
        this.ciclosService.add(this.promocion, this.valueNew).subscribe((res) => {
            if (res) {
                this.swalService.success("Ciclo añadido correctamente").then(() => {
                    this.getDataSource();
                    this.createForm = false;
                    this.valueNew = 0;
                });
            } else {
                this.swalService.error(res.errors[0]);
            }
        });
    }
}
